import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiList } from "./apiList.service";
import { receiveResponse } from "../models/chat.model";

@Injectable({
  providedIn: "root",
})
export class chatService {
  constructor(private readonly http: HttpClient, private _apiList: apiList) {}

  getChatsById(id: string, query: string): Observable<receiveResponse> {
      const headers = new HttpHeaders({ 'X-Skip-Loader': 'true' });
    return this.http
      .get<{
        data: receiveResponse;
      }>(`${environment.base_url}${this._apiList.chat}/${id}?${query}`, { headers })
      .pipe(map((res) => res.data));
  }

}
